export const tabOpenByClick = () => {
    const linksWithHash = document.querySelectorAll('.js-link-to-tab');

    if (0 !== linksWithHash.length) {
        linksWithHash.forEach((item) => {
            item.addEventListener('click', (e) => {
               const hash = item.href.split('#');
               const activeTabId = `${hash[1]}-tab`;

               console.log('bam!');
                $('#' + activeTabId).tab('show');
                // window.scrollTo(0, 0);
                // setTimeout(function() {
                //     window.scrollTo(0, 0);
                // }, 1);
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
                setTimeout(function() {
                    window.scroll({
                        top: 0,
                        behavior: 'smooth'
                    })
                }, 1);
            });
        });
    }
};
